import { render } from "./ApproveNewStudent.vue?vue&type=template&id=7dd74f4e&scoped=true"
import script from "./ApproveNewStudent.vue?vue&type=script&lang=js"
export * from "./ApproveNewStudent.vue?vue&type=script&lang=js"

import "./ApproveNewStudent.vue?vue&type=style&index=0&id=7dd74f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd74f4e"]])

export default __exports__